import DepositHistoryDialog from './DepositHistoryDialog';
export default DepositHistoryDialog;
